import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingDirectiveEntryStatus } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import DirectiveEntryDiagnosticEntryAwaitingManualStart from "./AwaitingManualStart";
import DirectiveEntryDiagnosticEntryInProgress from "./InProgress";
import DirectiveEntryDiagnosticEntryAwaitingClientReview from "./AwaitingClientReview";

const DirectiveEntryDiagnosticEntryOnGoingDirective = () => {
  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
  >();

  const directiveEntryStatus = forwarding.directive_entry.status;

  if (directiveEntryStatus === MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart) {
    return <DirectiveEntryDiagnosticEntryAwaitingManualStart />
  }

  if (directiveEntryStatus === MaintenanceForwardingDirectiveEntryStatus.InProgress) {
    return <DirectiveEntryDiagnosticEntryInProgress />
  }

  if (directiveEntryStatus === MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview) {
    return <DirectiveEntryDiagnosticEntryAwaitingClientReview />
  }

  return null;
}

export default DirectiveEntryDiagnosticEntryOnGoingDirective;
